import { Divisor, Typography } from '@recruit-robin/robin-theme/web-components';
import { Plus } from '@recruit-robin/robin-theme/web-icons';
import { motion } from 'motion/react';
import { useNavigate, useParams } from 'react-router-dom';

import { routes } from '@/config';
import { ListItem } from '@/entities/chat';
import { useDictionary } from '@/shared/lib/i18n';
import { useChatOverviewInfiniteQuery } from '../../api';
import { useStyles } from './List.styles';

const CreateChat = () => {
  const classes = useStyles();
  const dictionary = useDictionary();
  const navigate = useNavigate();

  return (
    <div css={classes.createChatButton} onClick={() => navigate(routes.robinJr.home)}>
      <Plus size={16} />
      <Typography variant={(v) => v.supporting.label} color={(c) => c.neutral.variant[70]} inline>
        {dictionary.createNewSearch}
      </Typography>
    </div>
  );
};

const NoChatsFound = () => {
  const classes = useStyles();
  const dictionary = useDictionary();

  return (
    <div css={classes.noDataFound}>
      <Typography variant={(v) => v.body.short} color={(c) => c.neutral.variant[70]}>
        {dictionary.noDataAvailable}
      </Typography>
    </div>
  );
};

export const List = () => {
  const classes = useStyles();
  const { data, isLoading, hasNextPage, isFetchingNextPage } = useChatOverviewInfiniteQuery();
  const navigate = useNavigate();
  const chatId = useChatId();

  const fetchNextPage = () => {};

  return (
    <div css={classes.root}>
      <div css={classes.header}>
        <Typography variant={(v) => v.heading[2]}>Chats</Typography>

        <CreateChat />
      </div>

      <Divisor />
      <div css={classes.listContainer}>
        <ListItem.Group>
          {isLoading ? (
            <ListItem.Group.Skeleton length={20} />
          ) : data.length > 0 ? (
            data.map((item) => (
              <ListItem
                key={item.id}
                item={item}
                onClick={() => navigate(routes.robinJr.chat(item.id))}
                isSelected={chatId === item.id}
              />
            ))
          ) : (
            <NoChatsFound />
          )}

          {hasNextPage && (
            <motion.div
              css={classes.fetchNextPageContainer}
              onViewportEnter={() => !isFetchingNextPage && fetchNextPage()}>
              <ListItem.Group.Skeleton length={4} />
            </motion.div>
          )}
        </ListItem.Group>
      </div>
    </div>
  );
};

export const useChatId = () => {
  const { id } = useParams<{ id: string }>();
  const isNumber = !isNaN(Number(id));

  if (!isNumber) return null;

  return Number(id);
};
